import { Component } from '@angular/core';
import { SharedComponents } from '../../../components/shared.module';
import { Tabs } from '../../../core/models/tab-field';
import { BaseLayoutComponent } from '../../base-layout.component';
import { ModelExecutionComponent } from './model-execution/model-execution.component';
import { OptimizerResultsComponent } from './optimizer-results/optimizer-results.component';
import { PreProcessingComponent } from './pre-processing/pre-processing.component';
import { SegmentationThresholdComponent } from './segmentation-threshold/segmentation-threshold.component';

@Component({
  selector: 'app-test-case-optimizer',
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: './test-case-optimizer.component.html',
  styleUrl: './test-case-optimizer.component.scss'
})
export class TestCaseOptimizerComponent extends BaseLayoutComponent {
  tabs : Tabs[] = [
    {
      label: "Pre Processing",
      component: PreProcessingComponent,
      view: 'pre_processing',
      disabled: false, 
    },
    {
      label: "Segmentation Threshold",
      component: SegmentationThresholdComponent,
      view: 'segmentation_threshold',
      disabled: false, 
    },
    {
      label: "Model Execution",
      component: ModelExecutionComponent,
      view: 'model_execution',
      disabled: false, 
    },
    {
      label:"Results",
      component: OptimizerResultsComponent,
      view: 'results',
      disabled: true, 
    }
   ];
  // userDetails: any;

  // ngOnInit() {
  //   this.userDetails = this.keycloakService.getKeycloakInstance().tokenParsed;
  //   this.createUsers();
  // }

  // createUsers() {
  //   const payload = {
  //     role: this.userDetails.realm_access?.roles[0] || '',
  //     username: this.userDetails.preferred_username || '',
  //     email: this.userDetails.email || '',
  //     fullname: this.userDetails.name || '',
  //     name: this.userDetails.given_name || ''
  //   };
  //   this.restTcoService.createUsers(payload).subscribe((item) => {
  //     this.tcoProjectService.setTcoUserId(item);
  //   });
  // }

}
